module.exports = __webpack_public_path__ + "img/ot-dark_purple.ef1236c4.svg";